<h2 *ngIf="!this.recoveryCode || this.recoveryCode == 'null'"> <i class="fa-solid fa-gift"></i>Hoşgeldin <span>{{user.name}}</span></h2>
<div class="auth-wrapper">
  <div class="auth-content">

    <div class="auth-bg"><span class="r"></span><span class="r s"></span><span class="r s"></span><span
      class="r"></span></div>
  <form class="card"  (submit)="onSubmit($event)">
    <dx-form class="card-body text-center" [formData]="formData" [disabled]="loading">

      <dxi-item dataField="password" editorType="dxTextBox"
        [editorOptions]="{ stylingMode: 'filled', placeholder: 'Şifre', mode: 'password' }">
        <dxi-validation-rule type="required" message="Bu alan gerekli."></dxi-validation-rule>
        <dxi-validation-rule type="custom" message="Şifre harf ve rakam içermeli." 
          [validationCallback]="passwordContainsLetterAndNumber">
        </dxi-validation-rule>
        <dxi-validation-rule type="custom" message="Şifre en az 6 hane olmalı." 
          [validationCallback]="passwordLengthCheck">
        </dxi-validation-rule>
        <dxo-label [visible]="false"></dxo-label>
      </dxi-item>

      <dxi-item dataField="confirmedPassword" editorType="dxTextBox"
        [editorOptions]="{ stylingMode: 'filled', placeholder: 'Tekrar Şifre', mode: 'password' }">
        <dxi-validation-rule type="required" message="Bu alan gerekli."></dxi-validation-rule>
        <dxi-validation-rule type="custom" message="Şifreler eşleşmiyor." [validationCallback]="confirmPassword">
        </dxi-validation-rule>
        <dxo-label [visible]="false"></dxo-label>
      </dxi-item>

      <dxi-item itemType="button">
        <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'changePasswordTemplate'">
        </dxo-button-options>
      </dxi-item>

      <ng-container *dxTemplate="let item of 'changePasswordTemplate'">
        <div>
          <span class="dx-button-text">
            <ng-container *ngIf="loading; else notLoading">
              <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
            </ng-container>
            <ng-template #notLoading>ŞİFREMİ DEĞİŞTİR</ng-template>
          </span>
        </div>
      </ng-container>

    </dx-form>
  </form>
</div>
</div>